module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/new/instagram-06b0b07b9c98c1d0549ca6c08177c1ab.svg";